import { api } from '@/lib/api';
import { buildListQueryString, type IListQueryOptions } from '@/lib/build-list-query';
import type { IApiResponse, INews, INewsCreate } from '@skystone/shared';

export type INewsListOptions = IListQueryOptions;

export const newsApi = {
  getAll: async (options?: INewsListOptions): Promise<INews[]> => {
    const result = await api.get<IApiResponse<INews[]>>(`/news${buildListQueryString(options)}`);
    return result.data;
  },

  create: async (body: INewsCreate): Promise<INews> => {
    const result = await api.post<IApiResponse<INews>>('/news', body);
    return result.data;
  },

  update: async (id: string, body: INewsCreate): Promise<INews> => {
    const result = await api.put<IApiResponse<INews>>(`/news/${id}`, body);
    return result.data;
  },

  setArchived: async (id: string, archived: boolean): Promise<void> => {
    await api.patch<void>(`/news/${id}/archive`, { archived });
  },
};
